import { validateQueryParams } from '../../utils/api/api-utils';
import {
  doGetQCXRequest,
  doPostQCXRequest,
  doPutQCXActivateRequest,
  doPutQCXInactivateRequest,
  doPutQCXRequest,
} from '../../utils/api/domain/domain-api-utils';
import { FILTER_ENDPOINT, TAXA_CONVERSAO_CAMBIO_ENDPOINT } from '../../utils/api/domain/domain-endpoint-utils';

async function fetchAll() {
  return doGetQCXRequest([
    TAXA_CONVERSAO_CAMBIO_ENDPOINT
  ]);
}

export async function fetchPaginate(params = []) {
  const validatedQueryParams = validateQueryParams(params);
  return doGetQCXRequest([TAXA_CONVERSAO_CAMBIO_ENDPOINT, 'filter/pagination'], validatedQueryParams);
}

export async function checkForDuplicates(data) {
  return doPostQCXRequest([TAXA_CONVERSAO_CAMBIO_ENDPOINT, 'check-duplicate'], data);
}

async function fetchByFilter(params = []) {
  const validatedParams = validateQueryParams(params);
  if (validatedParams.length) {
    return doGetQCXRequest([
      TAXA_CONVERSAO_CAMBIO_ENDPOINT, FILTER_ENDPOINT
    ], validatedParams);
  }
  return { data: [] };
}

async function fetchById(id) {
  return doGetQCXRequest([
    TAXA_CONVERSAO_CAMBIO_ENDPOINT,
    id
  ]);
}

async function register(data) {
  return doPostQCXRequest(
    [TAXA_CONVERSAO_CAMBIO_ENDPOINT],
    data
  );
}

async function save(data) {
  return doPutQCXRequest(
    [TAXA_CONVERSAO_CAMBIO_ENDPOINT],
    data
  );
}

async function activateById(id) {
  return doPutQCXActivateRequest(
    [TAXA_CONVERSAO_CAMBIO_ENDPOINT],
    id
  );
}

async function inactivateById(id) {
  return doPutQCXInactivateRequest(
    [TAXA_CONVERSAO_CAMBIO_ENDPOINT],
    id
  );
}

const taxaConversaoCambioAPI = {
  fetchAll,
  fetchByFilter,
  fetchById,
  register,
  save,
  activateById,
  inactivateById,
};

export {
  taxaConversaoCambioAPI,
  fetchAll,
  fetchByFilter,
  fetchById,
  register,
  save,
  activateById,
  inactivateById,
};
